<template>
    <div class="main-header">
        <div class="header-content">
            <a href="#"><img src="@/assets/logo.jpg" alt="osandarines"></a>
            <div class="titulo">
                <h1 v-if="titulo">{{titulo}}</h1>
                <h1 v-else>XI CARRERA POPULAR 10K DEL ROSCÓN</h1>
                <h2 v-if="subtitulo">{{subtitulo}}</h2>
                <h3>Inscripciones Online. Fecha límite: <span>22-01-2020</span></h3>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'rHeader',
        props:['titulo', 'subtitulo']

    }
</script>

<style lang="scss">
    @import '@/_static/base';
    .main-header {
        background-color: white;//$header-color;
        width: 100%;
        margin: 0 auto;
        border-radius: 15px 15px 0 0;


        & .header-content {
            display: flex;
            flex-direction: row;
            padding-top: 0.25rem;


            & .titulo {
                order: 1;
                flex: 1 1 auto;
                align-self: auto;
                display: flex;
                flex-direction: column;
                justify-content: center;
                color: black;

                & h1 {
                    font-size: 13px;
                    align-self: center;
                    order: 0;
                    flex: 0 1 auto;
                    margin-bottom: 0;
                }

                & h2 {
                    align-self: center;
                    order: 0;
                    flex: 0 1 auto;
                    margin-bottom: 0;
                }

                & h3 {
                    font-size: 11px;
                    font-weight: 700;
                    align-self: center;
                    order: 0;
                    flex: 0 1 auto;

                    & span {
                        text-decoration: underline;
                    }
                }
            }

            & a {
                order: 0;
                padding: 0 0.5rem;
                z-index: 50;
                flex: 0 1 auto;
                align-self: flex-start;
                & img {
                    width: 75px;
                    height: 75px;
                    border-radius: 50%;
                }
            }
        }
    }

    // Tablets
    @media (min-width: 768px) and (max-width: 1024px) {
        .main-header {
            & .header-content {
                width: 90vw;
                margin: 0 auto;
                padding-top: 0.25rem;

                & .titulo {

                    & h1 { font-size: 24px; align-self: center;}
                    & h3 { font-size: 20px;}
                }

                & a {
                    & img {
                        width: 110px;
                        height: 110px;
                        padding: 0;
                    }
                }
            }
        }

    }
    @media (min-width: 1200px) {
        .main-header {
            & .header-content {
                width: 80vw;
                max-width: 1140px;
                margin: 1.5rem  auto 0;
                padding-top: 0.25rem;

                & .titulo {

                    & h1 { font-size: 28px; align-self: center; margin-top: 0.5rem;}
                    & h3 { font-size: 24px; margin-top: 0;}
                }

                & a {
                    & img {
                        width: 100px;
                        height: 100px;
                        padding: 0;
                    }
                }
            }
        }
    }
</style>